<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>
    <div class="container-fluid mt--8">
      <div class="card shadow">
        <div class="row p-3">
          <div class="col-lg-6 col-6 mb-1" v-if="is_allowed_create">
            <button v-if="is_allowed_delete"
              :disabled="!showActionDelete"
              v-on:click="showConfirmationModal = true"
              class="btn btn-danger"
            >
              <i class="fa fa-trash"></i> Delete
            </button>
            <button
              v-on:click="onEditRow"
              :disabled="!showActionEdit"
              class="btn btn-primary"
            >
              <i class="fa fa-edit"></i> Edit
            </button>
            <button v-on:click="onCreateNewProduct" class="btn btn-primary">
              Create Prize
            </button>
          </div>
          <div class="col-6 pull-right">
            <div class="row">
              <label class="col-4 col-form-label form-control-label text-right">
                Brand
              </label>
              <div class="col-8">
                <model-list-select
                  :list="brandCodeOption"
                  v-model="watch_brand_code"
                  option-value="value"
                  option-text="text"
                  placeholder="select merchant item"
                >
                </model-list-select>
              </div>
            </div>
          </div>
        </div>
        <div v-if="message">
          <base-alert :type="message.type" :dismissible="true" @resetMessage="resetMessage">{{
            message.message
          }}</base-alert>
        </div>
        <div v-if="deleteMessages">
          <base-alert
            :type="deleteMessages[0].type"
            :dismissible="true"
            v-for="(row, index) in deleteMessages"
            :key="index"
            >{{ row.message }}</base-alert
          >
        </div>
        <vue-bootstrap4-table
          :rows="rows"
          :columns="columns"
          :config="config"
          :classes="classes"
          @on-select-row="onSelectRow"
          @on-unselect-row="onSelectRow"
          @refresh-data="onRefreshData"
        >
          <template slot="prize_type_id_column" slot-scope="props">
            <label v-if="props.cell_value == 1">
            Coins
            </label>
            <label v-if="props.cell_value == 2">
            Raffle Entries
            </label>
            <label v-if="props.cell_value == 3">
            Mobile Load
            </label>
            <label v-if="props.cell_value == 4">
            Voucher
            </label>
            <label v-if="props.cell_value == 5">
            Items
            </label>
             <label v-if="props.cell_value == 6">
            No Reward
            </label>
          </template>
        </vue-bootstrap4-table>
      </div>
    </div>
    <modal :show.sync="showConfirmationModal" modalClasses="modal-sm">
      <h3>Are you sure to delete these items?</h3>
      <ul>
        <li v-for="(row, index) in selectedItems" :key="index">
          {{ row.prize_name }}
        </li>
      </ul>
      <template slot="footer">
        <div class="row">
          <div class="col-lg-6">
            <base-button
              type="link"
              class="ml-auto btn-block"
              @click="showConfirmationModal = false"
              >No
            </base-button>
          </div>
          <div class="col-lg-6">
            <base-button
              type="primary"
              class="ml-auto btn-block"
              @click="onDeleteRow"
              >Yes
            </base-button>
          </div>
        </div>
      </template>
    </modal>
    <modal :show.sync="showModalCreate" modal-classes="modal-lg">
      <h3 slot="header" class="modal-title" id="modal-title-default">
        {{ this.titlePopup }} Prize Config
      </h3>
      <form @submit.prevent>
        <div class="row">
          <div class="col-lg-6">
            <div class="form-group has-label">
              <label class="form-control-label">
                Prize Type
              </label>
              <model-list-select
                :list="prizeTypeList"
                v-model="prizeModel.prize_type"
                option-value="value"
                option-text="text"
                placeholder="Select Prize Type"
                @input="onChangeSelectPrizeType($event)"
              >
              </model-list-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <div class="form-group has-label">
              <label class="form-control-label">
                Brand Code
              </label>
              <model-list-select
                :list="brandCodeOption"
                v-model="watch_brand_code"
                option-value="value"
                option-text="text"
                placeholder="select merchant item"
                :isDisabled="isBrandCodeDisabled"
              >
              </model-list-select>
            </div>
          </div>
          <div class="col-lg-6" v-if="voucherPrizeInputShow">
            <div class="form-group has-label">
              <label class="form-control-label">
                Merchant
              </label>
              <model-list-select
                :list="allMerchants"
                v-model="watch_merchantID"
                option-value="merchant_id"
                option-text="name"
                placeholder="select merchant item"
              >
              </model-list-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <base-input
              alternative=""
              label="Prize Name"
              input-classes="form-control"
              v-model="prizeModel.prize_name"
            />
          </div>

        </div>
        <div class="row" v-if="nonVoucherPrizeInputShow">
          <div class="col-lg-6">
            <base-input
              alternative=""
              label="Prize Value"
              input-classes="form-control"
              v-model="prizeModel.prize_value"
            />
          </div>
          <div class="col-lg-6" v-if="PrizeValueNumericShow">
            <base-input
              alternative=""
              label="Prize Value Numeric"
              input-classes="form-control"
              v-model="prizeModel.prize_value_numeric"
              type="number"
              :disabled="PrizeValueNumericInputDisabled"
            />
          </div>
        </div>
        <div class="row" >

        </div>
        <div class="row" v-if="voucherPrizeInputShow">
          <div class="col-lg-6">
            <div class="form-group has-label">
              <label class="form-control-label">
                Denomination
              </label>
              <model-list-select
                :list="Denominations"
                v-model="prizeModel.denomination_value"
                option-value="value"
                option-text="value"
                placeholder="select Denomination value"
              >
              </model-list-select>
            </div>
          </div>
          <div class="col-lg-6">
            <base-input
              alternative=""
              label="Denomination Quantity"
              input-classes="form-control"
              v-model="prizeModel.denomination_quantity"
              type="number"
            />
          </div>
        </div>       
        <div class="row">
          <div class="col-lg-6">
            <base-input type="file" id="file-input" accept="image/*" multiple @change="onFileChange($event)"/>
            <div id="preview-container">
              <div v-for="(file, index) in files" :key="index" class="preview">
                <img :src="file.targetUrl" class="img img-thumbnail">
                <button class="delete" @click="removeFile(index)">Delete</button>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6"></div>
        </div>
      </form>
      <template slot="footer">
        <base-button
          type="link"
          class="ml-auto"
          @click="showModalCreate = false"
          >Close/ Cancel
        </base-button>
        <button
          v-on:click="createUpdatePrize"
          class="btn btn-primary"
          :disabled="disableButtonSubmit"
        >
          Submit
        </button>
      </template>
    </modal>
  </div>
</template>
<script>
import VueBootstrap4Table from "vue-bootstrap4-table";
import api_loyalty from "../api/api";
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import "vue2-datepicker/index.css";

export default {
  name: "prizeList",
  data() {
    return {
      files:[],
      urlFile : '',
      is_allowed_create: false,
      is_loads3presigned: false,
      watch_brand_code: "PHFortune",
      watch_merchantID:"",
      uploadModel: {
        logoUrl: null,
        cardUrl: null,
        coverUrl: null,
        logoPresignedUrl: "",
        cardPresignedUrl: "",
        coverPresignedUrl: "",
        logoFile: null,
        cardFile: null,
        coverFile: null,
        cardFileUrls: [],
      },
      deleteMessages: [],
      showConfirmationModal: false,
      selectedItems: [],
      showActionEdit: false,
      showActionDelete: false,
      isBrandCodeDisabled: false,
      brandCodeOption: [],
      DateRangeModel: null,
      validDateRange: [],
      stockPeriodOption: [
        { text: "Weekly", value: 1 },
        { text: "Monthly", value: 2 },
        { text: "Campaign Period", value: 3 },
      ],
      prizeTypeList: [
        { text: "Coins", value: "1" },
        { text: "Raffle Entries", value: "2" },
        { text: "Mobile Load", value: "3" },
        { text: "Voucher", value: "4" },
        { text: "Items", value: "5" },
        { text: "No Reward", value: "6" },
      ],
      productTypeList: [
        { text: "Normal Item", value: "1" },
        { text: "Bound Item", value: "2" },
      ],
      boundItemInputDisabled: false,
      boundItemInputShow: false,
      nonVoucherPrizeInputShow: true,
      voucherPrizeInputShow: false,
      PrizeValueNumericShow: true,
      PrizeValueNumericInputDisabled:false,
      titlePopup: "Create",
      message: null,
      merchantData : {},
      prizeModel: {
        brandCode: "PHFortune",
        merchantID_voucher: "",
        prize_name: "",
        logoUrl: "",
        cardUrl: "",
        coverUrl: "",
        logoUrls: "",
        cardUrls: "",
        coverUrls: "",
        tagline_voucher: "",
        category_voucher: "",
        subCategory_voucher: "",
        price_voucher: 0,
        denomination_quantity: 1,
        denomination_value: 0,
        denomination_id_voucher:0,
        is_active_voucher: true,
        is_active_valid_date_voucher: true,
        valid_start_date_voucher: "",
        valid_end_date_voucher:"",
        create_date: new Date().toISOString(),
        modify_date: new Date().toISOString(),
        prize_type:1,
        prize_value:"",
        prize_value_numeric:1,
        imageUrls: []
      },
      showModalCreate: false,
      showModalDetail: false,
      allMerchants: [],
      Denominations: [],
      FortuneMerchants: [],
      CheMerchants: [],
      rows: [],
      allPrizes: null,
      columns: [
        {
          label: "ID",
          name: "id",
          slot_name: "action_button",
        },
        {
          label: "Brand",
          name: "brandCode",
          sort: true,
        },
        {
          label: "Prize Type",
          name: "prize_type",
          sort: true,
          slot_name: "prize_type_id_column",
        },
        {
          label: "Prize Name",
          name: "prize_name",
          sort: true,
        },
        {
          label: "Prize Value",
          name: "prize_value",
          sort: true,
        },
        {
          label: "Prize Value Numeric",
          name: "prize_value_numeric",
          sort: true,
        },
        {
          label: "Voucher Denomination Value",
          name: "denomination_value",
          sort: true,
        },
        {
          label: "Voucher Denomination Quantity",
          name: "denomination_quantity",
          sort: true,
        },
      ],
      config: {
        pagination: true,
        pagination_info: true,
        num_of_visibile_pagination_buttons: 7,
        per_page: 10,
        checkbox_rows: true,
        highlight_row_hover: true,
        rows_selectable: true,
        multi_column_sort: false,
        card_mode: false,
        selected_rows_info: true,
        per_page_options: [5, 10, 20, 30],
      },
      classes: {
        table: "table-striped table-bordered",
        row: {
          "my-row my-row2": true,
          "function-class": function(row) {
            return row.id == 1;
          },
        },
      },
    };
  },
  created() {
    this.is_allowed_delete = this.$store.getters.isLoginUserAdmin;
    this.mappingRole();
    this.onRefreshData();
    this.isBrandCodeDisabled = false;
    api_loyalty.fetchAllGiveawayMerchantList("PHFortune").then((data) => {
      try {
        if(data.isSuccess) {
          this.FortuneMerchants = data.data;
          this.allMerchants = data.data;
        }
      } catch (e) {
        console.log(e);
      }
    });
    api_loyalty.fetchAllGiveawayMerchantList("PHChe").then((data) => {
      try {
        if(data.isSuccess) {
          this.CheMerchants = data.data;
          this.allMerchants = data.data;
        }
      } catch (e) {
        console.log(e);
      }
    });
  },
  methods: {
    mappingRole() {
      let isChe = this.$store.getters.roleMappingData.some(object =>
        object.role.toLowerCase().includes('phche') &&
        object.menu.toLowerCase().includes('prizeitemconfig')
      );
      let isFortune = this.$store.getters.roleMappingData.some(object =>
        object.role.toLowerCase().includes('phft') ||
        object.role.toLowerCase().includes('fortune') &&
        object.menu.toLowerCase().includes('prizeitemconfig')
      );
      let isAdministrator = this.$store.getters.isLoginUserAdmin;
      this.brandCodeOption = [];
      if (isAdministrator || isChe)
      {
        this.brandCodeOption.push({ text: "Chesterfield", value: "PHChe" });
        this.BrandCodeModel = this.ChartBrandCodeModel = "PHChe";
        this.is_allowed_create = true;
        this.is_allowed_delete = true;
        this.watch_brand_code = "PHChe";
      }

      if (isAdministrator || isFortune)
      {
        this.brandCodeOption.push({ text: "Fortune", value: "PHFortune" });
        this.BrandCodeModel = this.ChartBrandCodeModel = "PHFortune";
        this.is_allowed_create = true;
        this.is_allowed_delete = true;
        this.watch_brand_code = "PHFortune";
      }
    },
    onBrandChanged(event) {
      switch (event.target.value) {
        case "PHChe":
          this.allMerchants = this.CheMerchants;
          break;
        default:
          this.allMerchants = this.FortuneMerchants;
          break;
      }
    },
    ValidateForm() {
      if (
        this.prizeModel.brandCode &&
        this.prizeModel.merchantID_voucher &&
        this.prizeModel.coverUrl &&
        this.prizeModel.price_voucher &&
        this.prizeModel.denomination_value &&
        this.prizeModel.denomination_quantity
      ) {
        return true;
      }
      return false;
    },
    resetMessage(){
      this.message = null;
      this.deleteMessages = [];
      this.selectedItems = [];
    },
    onResetForm() {
      this.prizeModel = {
        brandCode: "PHFortune",
        merchantID_voucher: "",
        prize_name: "",
        logoUrl: "",
        cardUrl: "",
        coverUrl: "",
        tagline_voucher: "",
        category_voucher: "",
        subCategory_voucher: "",
        price_voucher: 0,
        denomination_quantity: 1,
        denomination_value: 0,
        denomination_id_voucher:0,
        is_active_voucher: true,
        is_active_valid_date_voucher: true,
        valid_start_date_voucher: "",
        valid_end_date_voucher:"",
        create_date: new Date().toISOString(),
        modify_date: new Date().toISOString(),
        prize_type:1,
        prize_value:"",
        prize_value_numeric:1,
        imageUrls : []
      };
      this.uploadModel = {
        logoUrl: "",
        cardUrl: "",
        coverUrl: "",
        logoPresignedUrl: "",
        cardPresignedUrl: "",
        coverPresignedUrl: "",
      };
      this.isBrandCodeDisabled=false,
      this.boundItemInputDisabled= false;
      this.boundItemInputShow = true;
      this.nonVoucherPrizeInputShow = true;
      this.voucherPrizeInputShow = false;
      let momNow = this.$moment(new Date().toUTCString());
      let StartDate = momNow.format("YYYY-MM-DD");
      let EndDate= momNow.add(1, "months").format("YYYY-MM-DD");
      let momStart = this.$moment(new Date(StartDate)).format(
        "YYYY-MM-DD"
      );
      let momEnd = this.$moment(new Date(EndDate)).format(
        "YYYY-MM-DD"
      );
      this.prizeModel.valid_start_date_voucher = momStart;
      this.prizeModel.valid_end_date_voucher = momEnd;
      this.validDateRange = [momStart, momEnd];
      this.watch_merchantID="";
      this.files = [];
    },
    onCreateNewProduct() {
      this.showModalCreate = true;
      this.titlePopup = "Create";
      this.Denominations= [];
      this.onResetForm();
      this.isBrandCodeDisabled = false;
      // this.merchantData = {}
    },
    toggleActive() {},
    async onRefreshData() {
      api_loyalty
        .GetAllPrizeConfig(this.prizeModel.brandCode)
        .then((data) =>
        {
          try
          {
            if(data.isSuccess){
              this.rows = data.data;
              this.allPrizes = data.data;
            }

          } catch (e)
          {
            console.log(e);
          }
        });

      this.watch_merchantID="";
    },
    onSelectRow(payload) {
      this.showActionEdit = true;
      this.showActionDelete = true;
      this.selectedItems = payload.selected_items;
      if (payload.selected_items.length == 0) {
        this.showActionEdit = false;
        this.showActionDelete = false;
      }
      if (payload.selected_items.length > 1) {
        this.showActionEdit = false;
      }
    },
    onEditRow() {
      this.files = [];
      this.prizeModel = this.allPrizes.filter(
        (x) => x.id === this.selectedItems[0].id)[0];

      this.allMerchants.forEach(x => {
        if (x.merchant_id == this.prizeModel.merchantID_voucher) {
          let data = {
            merchant_id: x.merchant_id,
            name : x.name
          }
          this.merchantData = data;
          this.watch_merchantID = this.merchantData.merchant_id;  
        }
      })

      this.prizeModel.imageUrls.forEach((element) => {
        if (element.cardUrl != null) {
             var data = {
              url: element.cardUrl,
              targetUrl: element.cardUrl,
              type : 'card',
             }
             this.files.push(data)
           }
      })

      this.showModalCreate = true;
      this.titlePopup = "Update";
      this.isBrandCodeDisabled = true;

      if(this.prizeModel.prize_type == 4){
        this.nonVoucherPrizeInputShow = false;
        this.voucherPrizeInputShow = true;
      }else{
        if(this.prizeModel.prize_type  == 6)
        {
          this.PrizeValueNumericShow = false;
          this.PrizeValueNumericInputDisabled = true;
          this.prizeModel.prize_value_numeric =0;
        }
        else
        {
          this.PrizeValueNumericShow = true;
          this.PrizeValueNumericInputDisabled = false;
        }
        this.nonVoucherPrizeInputShow = true;
        this.voucherPrizeInputShow = false;
      }
    },
    onDeleteRow() {
      this.selectedItems.forEach((element) => {
        let deleteRequest = {
          id: element.id,
          brandCode: this.watch_brand_code
        };
        api_loyalty
          .DeletePrizeConfig(deleteRequest)
          .then((data) => {
            this.onRefreshData();
            let msg = {
              message:
                "Failed to delete prize item '" +
                element.prize_name +
                "'.",
              type: "danger",
            };

            if(data.isSuccess){
              msg = {
                message:
                  "Success delete prize item '" + element.prize_name + "'.",
                type: "success",
              };
            }
            this.deleteMessages.push(msg);
          })
          .catch((e) => {
            console.log(e);
            var msg = {
              message:
                "Failed to delete prize item '" +
                element.prize_name +
                "'.",
              type: "danger",
            };

            if (e.response && e.response.status === 401)
            {
              msg = {
                message: "You don't have a permission",
                type: 'danger'
              }
            }

            this.deleteMessages.push(msg);
          });
      });
      this.showConfirmationModal = false;
    },
    async createUpdatePrize() {
      if(this.prizeModel.prize_type  == 6)
      {
          this.prizeModel.prize_value_numeric =0;
      }
      if(this.prizeModel.prize_type  == 4) {
        // this.prizeModel.merchantID_voucher = this.merchantData.merchant_id;
        this.prizeModel.denomination_id_voucher = this.Denominations.filter((x) => x.value === this.prizeModel.denomination_value)[0].denomination_id_voucher;
      }

      if (this.files.length > 0) {
        this.files.forEach((f) => {
          if (f.type === 'card') {
            const exists = this.prizeModel.imageUrls.some(
              (image) => image.cardUrl === f.url
            );
            if (!exists) {
              var data = {
                cardUrl: f.url,
                logoUrl: null,
                coverUrl: null,
              };
              this.prizeModel.imageUrls.push(data);
            }
          }
        });
      }
      if (this.prizeModel.id) {
        this.prizeModel.modify_date = new Date().toISOString();
        this.prizeModel.brandCode = this.watch_brand_code;
        
        api_loyalty.UpdatePrizeConfig(this.prizeModel).then((data) => {
              if(data.isSuccess){
                this.message = {
                  message: "Prize Item updated successfully.",
                  type: "success",
                };
              }
              else{
                this.message = {
                  message : "Failed to Update Prize Item",
                  type : 'danger'
                }
              }
              this.onRefreshData();
        })
        .catch((e) => {
            console.log(e)
            if (e.response && e.response.status === 401) {
              this.message = {
                message: "You don't have a permission",
                type: 'danger'
              }  
            } else {
              this.message = {
                message : "Failed to Update Prize Item",
                type : 'danger'
              }
            }
        })
      } else {
        this.prizeModel.brandCode = this.watch_brand_code;
        this.prizeModel.create_date = new Date().toISOString();
        this.prizeModel.modify_date = new Date().toISOString();
        api_loyalty.AddPrizeConfig(this.prizeModel)
        .then((data) => {
          if(data.isSuccess){
              this.message = {
                message: "Prize Item created successfully.",
                type: "success",
              };
          }else{
            this.message = {
              message: "Failed to create Prize Item",
              type: "danger",
            };
          }
          this.onRefreshData();
        })
        .catch((e) => {
            console.log(e)
            if (e.response && e.response.status === 401) {
              this.message = {
                message: "You don't have a permission",
                type: 'danger'
              }  
            } else {
              this.message = {
                message : "Failed to create Prize Item",
                type : 'danger'
              }
            }
        })
      }

        this.files.forEach(x => {
          api_loyalty.S3PutObject(
            x.presignedUrl,
            x.file
          );
        })
      this.onResetForm();
      this.showModalCreate = false;          
    },
    onChangeSelectVoucherType(e) {    
      if(e == 2)
      {
        this.boundItemInputDisabled = true;
        this.boundItemInputShow = false;

        this.prizeModel.price_voucher = 0;
        this.prizeModel.is_active_valid_date_voucher = false;
        this.prizeModel.is_active_voucher = true;
      } 
      else
      {
        this.boundItemInputDisabled = false;
        this.boundItemInputShow = true;
      } 
    },
    onChangeSelectPrizeType(e) {
      if(e == 4){
        this.voucherPrizeInputShow = true;
        this.prizeModel.prize_value = "Voucher";
      }else{
        if(e == 6)
        {
          this.PrizeValueNumericShow = false;
          this.PrizeValueNumericInputDisabled = true;
        }
        else
        {
          this.PrizeValueNumericShow = true;
          this.PrizeValueNumericInputDisabled = false;
        }
        this.nonVoucherPrizeInputShow = true;
        this.voucherPrizeInputShow = false;
        this.prizeModel.denomination_quantity = 0;
      }
    },
    onFileChange(event) {
      const selectedFiles = event.target.files;
      if (!selectedFiles.length) return;

      selectedFiles.forEach((file) => {
        this.files.push({
            file: file,
            url: '',
            targetUrl: '',
            presignedUrl: '',
            type : 'card'
          });
        const reader = new FileReader();
        reader.onload = (e) => {
          this.is_loads3presigned = true;
          let fileData = this.files.find(f => f.file == file);
          fileData.targetUrl = e.target.result;
          api_loyalty
          .GenerateS3PresignedUploadUrl(
            "giftaway-catalog-image",
            file,
            this.prizeModel.merchantID_voucher +
              "_" +
              'card' +
              "_" +
              this.prizeModel.id,
              this.watch_brand_code
          )
          .then((data) => {
            try {
              if(data.isSuccess)
              {
                fileData.presignedUrl = data.data.s3Object.uploadUrl;
                fileData.url = data.data.s3Object.cdnUrl;
              }
            } catch (e) {
              console.log(e);
            }
            this.is_loads3presigned = false;
          });
        };
        reader.readAsDataURL(file);
      })
    },
    removeFile(index) {
      this.files.splice(index, 1);
      this.prizeModel.imageUrls.splice(index, 1);
    }
  },
  components: {
    VueBootstrap4Table,
    ModelListSelect
  },
  watch: {
    watch_brand_code: function(val) {
      this.prizeModel.brandCode = this.watch_brand_code;
      switch (val) {
        case "PHChe":
          this.allMerchants = this.CheMerchants;
          break;
        default:
          this.allMerchants = this.FortuneMerchants;
          break;
      }
      this.onRefreshData();
    },
  
   watch_merchantID: function(val) {
     if(val!="")
     {
        this.prizeModel.merchantID_voucher = val;
        api_loyalty.getMerchantDetail(val, this.watch_brand_code)
          .then((data) => {
            if(data.isSuccess)
            {
              this.Denominations = data.data.denominations;
            }
        });
      }
    },
  },
  computed: {
    disableButtonSubmit: function () {
      let isDisabled = false;
      
      if(this.prizeModel.prize_type == 4)
      {
        if((this.prizeModel.prize_name && this.prizeModel.brandCode && this.prizeModel.denomination_quantity)) 
        {
          isDisabled = false;
        }
        else
        {
          isDisabled = true;
        }

      }
      else
      {
        if((this.prizeModel.prize_name &&
        this.prizeModel.prize_value &&
        (this.prizeModel.prize_value_numeric !== null && this.prizeModel.prize_value_numeric !== ""))
        )
        {
          isDisabled = false;
        }
        else
        {
          isDisabled = true;
        }
      }

      return isDisabled;

    },
  }
};
</script>
<style scoped>
.preview {
  display: inline-block;
  margin: 5px;
}
.preview img {
  max-width: 100px;
  max-height: 100px;
  display: block;
}
.delete {
  background-color: red;
  color: white;
  border: none;
  cursor: pointer;
  display: block;
  margin-top: 5px;
}
</style>
